module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.new', {
            url: '/new?{name}&{productId:int}&{recipeId:int}&{cardId:int}&{pageNumber:int}',
            views: {
                'left-panel@': {
                    template: '<wow-new-products-nav></wow-new-products-nav>'
                },
                'center-panel@': {
                    template: '<wow-card-list><wow-new-products-list></wow-new-products-list></wow-card-list>'
                },
                'sticky-header@': {
                    controller: [
                        '$scope', '$state', 'FeatureService', 'NewProductsService', function ($scope, $state, featureService, newProductsService) {
                            if (!featureService.isEnabled(featureService.features.newProductsPage)) {
                                $state.go('shop.404error');
                            }

                            $scope.redirectTo = 'shop.browse';
                            Object.defineProperty($scope, 'title', {
                                get() {
                                    return `New Products${newProductsService.totalRecordCount
                                        ? ` (${newProductsService.totalRecordCount})`
                                        : ''}`;
                                }
                            });
                        }
                    ],
                    template: '<oly-sticky-header-with-text ng-if="breakpointService.isInSmallFormat"></oly-sticky-header-with-text>'
                }
            },
            data: {
                analytics: `bws:web:new`,
                pageMetadata: {
                    title: 'Shop New Products',
                    metaDescription: 'Shop New Products'
                },
                showBothPanelsInSmallFormat: true
            }
        });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/new.js
 **/